import { render, staticRenderFns } from "./work_question_config.vue?vue&type=template&id=fa50f866"
import script from "./work_question_config.vue?vue&type=script&lang=js"
export * from "./work_question_config.vue?vue&type=script&lang=js"
import style0 from "./work_question_config.vue?vue&type=style&index=0&id=fa50f866&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports